import React, { useState } from "react";
import Layout from "../components/Layout/Layout";
import toast from "react-hot-toast";
import { FiMail, FiPhone, FiClock, FiSend } from "react-icons/fi";
import axios from "axios";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const PALETTE = {
    DARK_NAVY: "#1C2E4A",
    ACCENT_BROWN: "#7C4F2B",
    LIGHT_CREAM: "#FAF8F5",
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // FORMSUBMIT.CO AJAX SUBMISSION (USING NATIVE FETCH TO AVOID CORS/AUTH CLASH)
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);

      const response = await fetch(
        "https://formsubmit.co/ajax/support@russhberry.com",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            ...formData,
            _subject: `New Inquiry: ${formData.subject} - Russh Berry`,
            _template: "table",
            _captcha: "false",
          }),
        },
      );

      const data = await response.json();

      if (data?.success === "true" || data?.success === true || data?.message) {
        toast.success("Your message has been sent to our concierge.");
        setFormData({
          name: "",
          email: "",
          phone: "",
          subject: "",
          message: "",
        });
      } else {
        toast.error("Failed to send message. Please try again.");
      }
    } catch (error) {
      console.error("Contact Form Error:", error);
      toast.error("Something went wrong. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout
      title={
        "Russh Berry | Premium Men's Clothing Brand with Custom Sizes | Contact Us"
      }
    >
      <div
        className="min-h-screen pt-24 pb-16 transition-colors duration-500"
        style={{ backgroundColor: PALETTE.LIGHT_CREAM }}
      >
        <div className="max-w-7xl mx-auto px-6 lg:px-12 pt-12">
          <div className="text-center max-w-2xl mx-auto mb-20">
            <p
              className="text-xs sm:text-sm font-semibold tracking-[0.3em] uppercase mb-3"
              style={{ color: PALETTE.ACCENT_BROWN }}
            >
              Russh Berry Concierge
            </p>
            <h1
              className="text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight mb-6"
              style={{ color: PALETTE.DARK_NAVY }}
            >
              At Your Service
            </h1>
            <div
              className="w-16 h-[1px] mx-auto mb-6"
              style={{ backgroundColor: PALETTE.ACCENT_BROWN }}
            />
            <p className="text-gray-600 text-sm sm:text-base font-light leading-relaxed">
              We invite you to reach out for bespoke styling advice, order
              inquiries, or private consultations. Our dedicated team is
              committed to providing an exceptional experience.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-stretch">
            <div
              className="lg:col-span-5 bg-white p-8 sm:p-12 shadow-xl border border-gray-100/80 rounded-none relative overflow-hidden flex flex-col justify-between"
              style={{ borderTop: `4px solid ${PALETTE.DARK_NAVY}` }}
            >
              <div>
                <h2
                  className="text-2xl font-light tracking-wider uppercase mb-8"
                  style={{ color: PALETTE.DARK_NAVY }}
                >
                  Client Relations
                </h2>

                <div className="space-y-8 font-light">
                  <div className="flex items-start gap-5 group">
                    <div
                      className="w-10 h-10 flex items-center justify-center shrink-0 rounded-full bg-[#FAF8F5] transition-transform duration-300 group-hover:scale-110"
                      style={{ color: PALETTE.ACCENT_BROWN }}
                    >
                      <FiMail size={18} />
                    </div>
                    <div>
                      <p className="text-xs tracking-widest uppercase text-gray-400 font-medium mb-1">
                        Email Inquiries
                      </p>
                      <a
                        href="mailto:support@russhberry.com"
                        className="text-base text-gray-800 transition-colors hover:underline"
                        style={{ textDecorationColor: PALETTE.ACCENT_BROWN }}
                      >
                        support@russhberry.com
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start gap-5 group">
                    <div
                      className="w-10 h-10 flex items-center justify-center shrink-0 rounded-full bg-[#FAF8F5] transition-transform duration-300 group-hover:scale-110"
                      style={{ color: PALETTE.ACCENT_BROWN }}
                    >
                      <FiPhone size={18} />
                    </div>
                    <div>
                      <p className="text-xs tracking-widest uppercase text-gray-400 font-medium mb-1">
                        Private Assistance
                      </p>
                      <p className="text-base text-gray-800">+91 92596 13915</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-5 group">
                    <div
                      className="w-10 h-10 flex items-center justify-center shrink-0 rounded-full bg-[#FAF8F5] transition-transform duration-300 group-hover:scale-110"
                      style={{ color: PALETTE.ACCENT_BROWN }}
                    >
                      <FiClock size={18} />
                    </div>
                    <div>
                      <p className="text-xs tracking-widest uppercase text-gray-400 font-medium mb-1">
                        Operating Hours
                      </p>
                      <p className="text-base text-gray-800">
                        Monday – Saturday
                        <br />
                        <span className="text-sm text-gray-500">
                          10:00 AM – 7:00 PM IST
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-12 pt-8 border-t border-gray-100 flex items-center justify-between">
                <span className="text-xs tracking-widest uppercase text-gray-400 font-medium">
                  Russh Berry Fashion
                </span>
                <div
                  className="w-2 h-2 rounded-full"
                  style={{ backgroundColor: PALETTE.ACCENT_BROWN }}
                />
              </div>
            </div>

            <div
              className="lg:col-span-7 bg-white p-8 sm:p-12 lg:p-16 shadow-xl border border-gray-100/80 flex flex-col justify-between"
              style={{ borderTop: `4px solid ${PALETTE.DARK_NAVY}` }}
            >
              <div>
                <h3
                  className="text-2xl font-light tracking-wider uppercase mb-2"
                  style={{ color: PALETTE.DARK_NAVY }}
                >
                  Send a Message
                </h3>
                <p className="text-sm text-gray-500 font-light mb-8">
                  Please fill out the form below and an advisor will respond
                  within 24 hours.
                </p>

                <form onSubmit={handleSubmit} className="space-y-6">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-xs font-medium tracking-widest uppercase text-gray-600 mb-2">
                        Full Name *
                      </label>
                      <input
                        type="text"
                        name="name"
                        required
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="Lord / Lady..."
                        className="w-full bg-transparent border-b border-gray-300 py-3 text-sm text-gray-800 focus:outline-none focus:border-[#1C2E4A] transition-colors placeholder:text-gray-300 font-light"
                      />
                    </div>

                    <div>
                      <label className="block text-xs font-medium tracking-widest uppercase text-gray-600 mb-2">
                        Email Address *
                      </label>
                      <input
                        type="email"
                        name="email"
                        required
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="client@domain.com"
                        className="w-full bg-transparent border-b border-gray-300 py-3 text-sm text-gray-800 focus:outline-none focus:border-[#1C2E4A] transition-colors placeholder:text-gray-300 font-light"
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-xs font-medium tracking-widest uppercase text-gray-600 mb-2">
                        Phone Number
                      </label>
                      <input
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        placeholder="+91..."
                        className="w-full bg-transparent border-b border-gray-300 py-3 text-sm text-gray-800 focus:outline-none focus:border-[#1C2E4A] transition-colors placeholder:text-gray-300 font-light"
                      />
                    </div>

                    <div>
                      <label className="block text-xs font-medium tracking-widest uppercase text-gray-600 mb-2">
                        Subject *
                      </label>
                      <select
                        name="subject"
                        required
                        value={formData.subject}
                        onChange={handleChange}
                        className="w-full bg-transparent border-b border-gray-300 py-3 text-sm text-gray-800 focus:outline-none focus:border-[#1C2E4A] transition-colors font-light cursor-pointer"
                      >
                        <option value="" disabled className="text-gray-300">
                          Select an inquiry type...
                        </option>
                        <option value="Order Status">
                          Order Status & Shipping
                        </option>
                        <option value="Bespoke Styling">
                          Bespoke Styling Consultation
                        </option>
                        <option value="Returns">Returns & Exchanges</option>
                        <option value="General">General Inquiry</option>
                      </select>
                    </div>
                  </div>

                  <div className="pt-2">
                    <label className="block text-xs font-medium tracking-widest uppercase text-gray-600 mb-2">
                      Your Message *
                    </label>
                    <textarea
                      name="message"
                      required
                      rows="4"
                      value={formData.message}
                      onChange={handleChange}
                      placeholder="How may we assist you?"
                      className="w-full bg-transparent border-b border-gray-300 py-3 text-sm text-gray-800 focus:outline-none focus:border-[#1C2E4A] transition-colors placeholder:text-gray-300 font-light resize-none"
                    ></textarea>
                  </div>

                  <div className="pt-6">
                    <button
                      type="submit"
                      disabled={loading}
                      className="w-full border border-black sm:w-auto px-12 py-4 text-xs font-semibold tracking-[0.25em] uppercase text-white transition-all duration-300 flex items-center justify-center gap-3 disabled:opacity-50"
                      style={{
                        backgroundColor: "transparent",
                        color: "black",
                        borderColor: "black",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "black";
                        e.currentTarget.style.color = "white";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "transparent";
                        e.currentTarget.style.color = "black";
                      }}
                    >
                      <span>
                        {loading ? "Transmitting..." : "Submit Inquiry"}
                      </span>
                      <FiSend className="text-sm" />
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};;

export default Contact;
